import { render, staticRenderFns } from "./RiskCategories.vue?vue&type=template&id=4bd4e225&"
import script from "./RiskCategories.vue?vue&type=script&lang=js&"
export * from "./RiskCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports